import React from 'react'

import {
  CircularProgress,
  createStyles,
  makeStyles,
  Modal,
} from '@material-ui/core'

import LinearProgressWithLabel from './LinearProgressWithLabel'

const useStyles = makeStyles(() =>
  createStyles({
    readingModalDiv: {
      display: 'table',
      width: '100%',
      height: '100%',
      color: '#EEEEEE',
      fontSize: '65px',
      textAlign: 'center',
      '&:focus': {
        outline: 'none',
      },
    },
    readingModalChild: {
      display: 'table-cell',
      verticalAlign: 'middle',
    },
    readingModalText: {
      margin: '0 0 5px 10px',
    },
    readingModalBar: {
      width: '60%',
      margin: 'auto',
    },
  })
)

type Props = {
  open: boolean
  progress: number
  message: string
  color: 'primary' | 'secondary' | undefined
}

const ModalWithLinearProgress: React.FC<Props> = (props: Props) => {
  const classes = useStyles()

  return (
    <Modal
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className={classes.readingModalDiv}>
        <div className={classes.readingModalChild}>
          <CircularProgress size="60px" />
          <label className={classes.readingModalText}>{props.message}</label>
          <div className={classes.readingModalBar}>
            <LinearProgressWithLabel
              value={props.progress}
              color={props.color}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalWithLinearProgress
